<template>
  <div class="error-page">
    <b-container>
      <div class="errorContainer mx-auto">
        <h3 class="errorInfo">
            This page is under development
        </h3>
      </div>

    </b-container>
  </div>
</template>

<script>
export default {
  name: 'ErrorPage',
};
</script>

<style src="./UnderDevelopment.scss" lang="scss" scoped />
